import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { SvcServices } from "../services/svc.service";
import { ContentService } from "../services/content.service";
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css']
})
export class PagenotfoundComponent implements OnInit {

  constructor(
  	private _svcService: SvcServices,
    private _contentService: ContentService,
    @Inject(PLATFORM_ID) private platformId: string
  ) { }
  ngOnInit() {
  }
  ngAfterViewInit(){
    //this._svcService.isSignOnLoaded.emit(true);
    if (isPlatformBrowser(this.platformId)) {
      document.querySelectorAll('.loader').forEach((selects) => {
        selects.remove();
      });
    }
    //this._renderer.removeChild(this._el.nativeElement, spinnerDiv);
    this._contentService.componentLoaded.emit(true);
  }

}
